// extracted by mini-css-extract-plugin
export const rightSection = "C_br";
export const card = "C_K";
export const loading = "C_bs";
export const overlay = "C_bt";
export const form = "C_t";
export const leftSection = "C_bv";
export const banner = "C_bw";
export const bannerContainer = "C_bx";
export const bannerContentContainer = "C_by";
export const bannerAppIcon = "C_bz";
export const bannerSpace = "C_bB";
export const bannerSlogan1 = "C_bC";
export const bannerSlogan2 = "C_bD";